import { render, staticRenderFns } from "./DetailVoidPembayaran.vue?vue&type=template&id=33188501&"
import script from "./DetailVoidPembayaran.vue?vue&type=script&lang=js&"
export * from "./DetailVoidPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports